import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { BtnTheme } from '../../type/btnTheme.type';
import { FontWeight } from '../../type/fontWeight.type';
import { BtnType } from '../../type/btnType.type';
import { ThemePalette } from '@angular/material/core';
import { BtnIconPosition } from '../../type/btnIconPosition.type';

@Component({
  selector: 'app-basic-btn-with-icon',
  templateUrl: './basic-btn-with-icon.component.html',
  styleUrls: ['./basic-btn-with-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasicBtnWithIconComponent {
  @Input('theme') theme: BtnTheme;
  @Input('text') text: string = 'Placeholder';
  @Input('icon') icon: string = 'favorite';
  @Input('iconSrc') iconSrc: string;
  @Input('color') color: ThemePalette;
  @Input('uppercase') uppercase: boolean = true;
  @Input('disabled') disabled: boolean = false;
  @Input('iconColor') iconColor: ThemePalette;
  @Input('iconPosition') iconPosition: BtnIconPosition = 'right';
  @Input('fontWeight') fontWeight: FontWeight = 400;
  @Input('type') type: BtnType = 'button';
}
